import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import FormContext from "../context/formContext";


const BackLogout = () => {
  const navigate = useNavigate();
  const context = useContext(FormContext);


  const { backward,setbackward,reversepage,setReversepage } = context;

  const previouspage = () =>{
    // setbackward(false);
    setbackward(true);
    setReversepage(true);
    navigate(-1)
  }

  console.log(reversepage,"144")


  const handleLogout = () => {
    localStorage.removeItem("userId");
    localStorage.removeItem("studentId");
    navigate("/");
  };


  return (
    <>
      <div className="d-flex justify-content-between mt-3">
        {/* <div>
          <button
            className="btn btn-sm"
            style={{ border: "1px solid #a6191f", color: "#a6191f" }}
            onClick={() => navigate(-1)}
          >
            <i className="fa-solid fa-left-long"></i> Back
          </button>
        </div> */}
        <div className="backward">
          <button
            className="btn btn-sm"
            style={{ border: "1px solid #a6191f", color: "#a6191f" }}
            // onClick={() => navigate(-1)}
            onClick={previouspage}
          >
            <i className="fa-solid fa-left-long"></i> Back
          </button>
        </div>
        <div>
          <button
            className="btn btn-sm rounded-3"
            data-toggle="tooltip"
            data-placement="bottom"
            title="Logout"
            style={{ border: "1px solid #a6191f", color: "#a6191f" }}
            onClick={() => handleLogout()}
          >
            <i className="fa-solid fa-arrow-right-from-bracket"></i>{" "}
            <span>Log Out</span>
          </button>
        </div>
      </div>
    </>
  );
};

export default BackLogout;
